var ProviderCapabilities = function () {
  function ProviderCapabilities(reusesExistingSession) {
    if (reusesExistingSession === void 0) {
      reusesExistingSession = false;
    }

    this.reusesExistingSession = reusesExistingSession;
  }

  return ProviderCapabilities;
}();

export default ProviderCapabilities;